import useApp from 'hooks/useApp'
import Lib from 'library'
import { useNavigate } from 'react-router-dom'
import Native from 'library/native'
import { detailResultDataState, reqCdState, transmitRequestState, selectedOrgsState, certFromState, certTxIdState, resultDataState, checkedResultDataState } from 'views/data/states'
import { consentListState } from 'views/mydata/manage/states'
import { useRecoilValue, useSetRecoilState } from 'recoil'

const useCertifications = () => {

	const App = useApp()
	const navigate = useNavigate()
	const selectedOrgs = useRecoilValue(selectedOrgsState)
	const consentList = useRecoilValue(consentListState)
	const certFrom = useRecoilValue(certFromState)
	const setCertTxId = useSetRecoilState(certTxIdState)
	const transmitRequest = useRecoilValue(transmitRequestState)

	const setResultData = useSetRecoilState(resultDataState)
	const checkedResultData = useRecoilValue(checkedResultDataState)

	const setDetailResultData = useSetRecoilState(detailResultDataState)
	const setReqCd = useSetRecoilState(reqCdState)

	// 전송오구권 만들기
	const getConsent = (org) => {
		console.log('전송요구권 만들기 >>>>', org)

		// 일주일 후
		const oneWeekLater = Lib.dateFormat(new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 7)), "")

		const consent = {
			// add_cycle: transmitRequest.isScheduled === true ? transmitRequest.isCycle : "",
			// fnd_cycle: transmitRequest.isScheduled === true ? transmitRequest.isCycle : "",
			add_cycle: "1/1w",
			fnd_cycle: "1/1w",// 특적 기관의 경우 해당 값이 존재해야 가능
			consent_title: org.insttNm,
			end_date:oneWeekLater,
			is_scheduled: "true",
			period: oneWeekLater,
			purpose: "상세정보 전송요구를 위한 가입상품목록 조회",
			rcv_org_code: process.env.REACT_APP_SND_ORG_CODE,
			snd_org_code: org.insttCd,
			target_info: [
				{ scope: `${org.indstCd.toLowerCase()}.list` }
			]
		}

		if (certFrom === "detail" || certFrom === "extend" || certFrom === "modify") { // 상세연동, 변경, 연장 일 경우
			// period = 99991231 으로 고정값 동일하게 사용
			consent.period = "99991231" // 공동인증서와 공통 사용으로 해당 period 추가
			// 전송 기간 1~5년으로 선택받아 들어오기 때문에 공통으로 수정
			consent.end_date = Lib.dateFormat(transmitRequest.endDate, "") // 공동인증서의 경우 end_date
			consent.end_terms = transmitRequest.endTerms
			consent.is_scheduled = transmitRequest.isScheduled === true ? "true" : "false"
			consent.add_cycle = transmitRequest.isScheduled === true ? transmitRequest.isCycle : ""
			consent.fnd_cycle = transmitRequest.isScheduled === true ? transmitRequest.isCycle : ""

			if (org.indstCd === "bank" || org.indstCd === "efin") {
				consent.is_consent_trans_memo = (transmitRequest.memo === true ? "true" : "false")
			}

			if (org.indstCd === "card" || org.indstCd === "efin" || org.indstCd === "telecom") {
				consent.is_consent_merchant_name_regno = (transmitRequest.regno === true ? "true" : "false")
			}

			if (org.indstCd === "efin") {
				consent.is_consent_trans_category = (transmitRequest.category === true ? "true" : "false")
			}

			const targetList = Lib.deepCopy(org.targetInfoList)
			targetList.forEach(target => {
				target.asset_list?.forEach(asset => {
					delete asset.checked
					delete asset.errDesc
					delete asset.sucesYn
					delete asset.assetNm
					delete asset.assetTpNm
					for (const key in asset) {
						console.log("asset[key] : ", asset[key]);
						// if(asset[key] === null) asset[key] = ""
						if (asset[key] === null || asset[key] === "") {
							delete asset[key]
						}
					}
				})
				if(target.asset_list &&  target.asset_list.length === 0) {
					delete target.asset_list
				}
			})
			consent.target_info = targetList
		}
		console.log({ consent })
		return consent
	}

	// 공동인증
	const goCommonCert = () => {
		console.log({ checkedResultData })
		console.log({ selectedOrgs })
		console.log({ certFrom })
		console.log({ transmitRequest })
		console.log({ consentList })
		if (certFrom !== "modify" && !selectedOrgs || selectedOrgs.length < 1) {
			App.alert("선택된 기관이 없습니다.")
			return
		}

		// 인증서 목록 보이기
		Native.execute("Cert", "showCertList", result => {
			const json = JSON.parse(result)
			const oneWeekLater = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 7))
			if (json.resultCode === "0") {
				const ucpidData = []
				let listToLoop
				if (certFrom === "detail") {
					listToLoop = checkedResultData
				} else {
					listToLoop = selectedOrgs
				}
				listToLoop.forEach(org => {
					const consent = getConsent(org)
					ucpidData.push({
						orgCode: org.insttCd,
						end_date: Lib.dateFormat(oneWeekLater, ""),
						ucpidRequestInfo: {
							userAgreement: "금융분야 마이데이터 통합인증을 위한 인증서 본인 확인서비스 이용약관, 개인정보 처리, 고유식별정보 수집·이용 및 위탁에 동의합니다.",
							userAgreeInfo: {
								realName: true,
								gender: true,
								nationalInfo: true,
								birthDate: true,
								ci: true
							},
							ispUrlInfo: "myapidev.moneey.co.kr",
							ucpidNonce: ""
						},
						consentInfo: {
							consent: consent,
							consentNonce: ""
						}
					})
				})

				console.log({ ucpidData })

				Native.execute("UCPID", "UCPIDSignData", result => {
					try {
						const json = JSON.parse(result)
						if (json.resultCode === "0") {
							const signedDataList = json.result.ucpid.signedDataList
							const caOrg = json.result.ucpid.caOrg
							const nonce = json.result.nonce

							let params = []
							for (let i = 0; i < signedDataList.length; i++) {
								params.push({
									ca_code: caOrg,
									consent_nonce: nonce[i].consentNonce,
									org_code: signedDataList[i].orgCode,
									password: signedDataList[i].signedConsent,
									password_len: signedDataList[i].signedConsent.length,
									request_type: "0",
									signed_person_info_req: signedDataList[i].signedPersonInfoReq,
									signed_person_info_req_len: signedDataList[i].signedPersonInfoReq.length,
									ucpid_nonce: nonce[i].ucpidNonce,
									username: "c0mFp8B9GBw7g0fA7px8d3NCdcyhT1E//anDOyPBKkKXmhDFLVMU6G3S+bHd1STgPoEZUiejxYQPvaFWZR26jw==" // FIXME: 하드코딩, 후에는 username 삭제
								})
							}

							let url
							if (certFrom === "detail" || certFrom === "extend" || certFrom === "modify") {
								url = "/api/data/lnkup/intgr/auth/step2"
							} else {
								url = "/api/data/lnkup/intgr/auth/step1"
							}

							App.showLoading()
							Lib.axios({
								url: url,
								method: "post",
								timeout: 1000 * 180,
								data: params,
								onSuccess: data => {
									console.log(data)
									let url
									if (certFrom === "detail" || certFrom === "modify") {
										setDetailResultData(data)
										url = "/data/detailLinkResult"
									} else if (certFrom === "extend") {
										setResultData(data)
										url = "/mydata/manageResult"
									} else {
										setResultData(data)
										url = "/data/dataLinkResult"
									}
									navigate(url)
								},
								onComplete: () => {
									App.hideLoading()
								},
								onError: error => {
									console.log(`${error}`);
								}
							})
						} else {
							App.alert(`${json.resultCode}: 에러가 발생했습니다.`)
						}
					} catch (error) {
						App.alert(`${error.name}: ${error.message}`)
					}

				}, { key: JSON.stringify(ucpidData) })


			} else if (json.resultCode === "2") {
				/* 창 취소 */
			} else {
				App.showAlert(`${json.resultCode}: 에러가 발생했습니다.`)
				console.log(json.resultCode)
			}
		}, {
			input_type: '1', // 0 or n :number , 1 or c : character , 2 or s : serial, 3 or a : 인증서
			type: "1", // "type" : "0"(일반 보안 입력 키패드) or "1"(인증서비밀번호) or "2"(주민등록번호) or "3"(입력+주민번호)
			nfilter: { // nFilter 옵션
				public_key: "MDIwGhMABBYCACB19VlS754wwUAdImm7bytbXcxLBBT0KP7JpUvB/tUgV+WiMZAMM8SkfQ==",
				max_length: 50, // int 입력값 최대 자릿수(최대:64)
				desc: '인증서비밀번호' // activity 방식에서 상단에 Input Box 위에 있는 텍스트
			}
		})
	}

	// 사설인증 (네이버)
	const goNaverCert = () => {
		console.log({ checkedResultData })
		console.log({ selectedOrgs })
		console.log({ certFrom })
		console.log({ transmitRequest })
		console.log({ consentList })
		if (certFrom !== "modify" && !selectedOrgs || selectedOrgs.length < 1) {
			App.alert("선택된 기관이 없습니다.")
			return
		}

		// const selectedOrgs = App.data.orgs

		let listToLoop
		if (certFrom === "detail") {
			listToLoop = checkedResultData
		} else {
			listToLoop = selectedOrgs
		}

		const params = {
			consent_cnt: listToLoop.length,
			consent_list: [],
			consent_type: "1",
			device_browser: "HY",
			device_code: "MO"
		}

		console.log({ listToLoop })
		const consent_list = listToLoop.map(org => {
			return getConsent(org)
		})

		params.consent_list = consent_list
		let url
		if (certFrom === "detail" || certFrom === "extend" || certFrom === "modify") {
			url = `/api/data/lnkup/intgr/auth/req/step2/naver`
			if (certFrom === "modify") {
				params.clsfc_code = "CHNG"
			} else if (certFrom === "extend") {
				params.clsfc_code = "EXPND"
			}
		} else {
			url = `/api/data/lnkup/intgr/auth/req/step1/naver`
		}

		console.log({ params })

		App.showLoading()
		Lib.post({
			url: url,
			timeout: 1000 * 180,
			data: params,
			headers: {
				"Content-Type": "application/json;charset=UTF-8"
			},
			onSuccess: data => {
				handleNaverRequest(data)
			}
		})
		/* Lib.post(url, params, data => {
			handleNaverRequest(data)
		}) */

	}

	// 네이버 리퀘스트 응답 처리하기
	const handleNaverRequest = data => {
		let url
		if (Native.getUserAgent() === "ios") {
			url = data.sign_ios_app_scheme_url
		} else {
			url = data.sign_aos_app_scheme_url
		}

		setCertTxId(data.cert_tx_id)
		Native.execute("AppManager", "openScheme", res => {
			const json = JSON.parse(res)

			if (json.resultCode === "1") {
				App.showAlert({
					msg: `네이버인증 앱이 설치되지 않았거나 버전이 낮습니다. 설치화면으로 이동하시겠습니까?`,
					confirm: true,
					ok: "확인",
					cancel: "취소",
					onOk: () => {
						App.hideLoading()
						if (App.device.os.toLowerCase() === "android") {
							Native.execute("AppManager", "openScheme", function (result) { console.log(JSON.parse(result).result) }, { url: "https://play.google.com/store/apps/details?id=com.nhn.android.search" })
						} else {
							Native.execute("AppManager", "openScheme", function (result) { console.log(JSON.parse(result).result) }, { url: "itms-apps://itunes.apple.com/kr/app/apple-store/id393499958?mt=8" })
						}
					},
					onCancel: () => {
						App.hideLoading()
						// navigate("/data/selectCertType")
					},
				})
			}
			console.log(res)
		}, { url: url })
		// App.js wakeup 으로
	}

	// 개별 인증
	const goIndividualCert = () => {
		console.log({ checkedResultData })
		console.log({ selectedOrgs })
		console.log({ certFrom })
		console.log({ transmitRequest })
		console.log({ consentList })
		if (certFrom !== "modify" && selectedOrgs.length < 1) {
			App.alert("선택된 기관이 없습니다.")
			return
		}

		let url = `${App.server}/api/auth/authorize?org_code=${selectedOrgs[0].insttCd}`
		Native.execute("Popup", "openPopup", () => { }, {
			view_id: "individual_cert_pop",
			url: url,
			title: `${App.appName} 개별인증`
		})
	}

	return { getConsent, goCommonCert, goNaverCert, goIndividualCert }
}

export default useCertifications